require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./project-copenhagen-residence.json") })
        }
      }, "path---project-copenhagen-residence");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---project-copenhagen-residence!./.cache/json/project-copenhagen-residence.json
// module id = 564
// module chunks = 231608221292675